import { TextField } from '@mui/material';
import React from 'react';
import { IDefaultInput } from '@components/types';

const DefaultInput = ({
  label,
  id,
  onChange,
  required,
  name,
  error,
  helperText,
  defaultValue,
  disabled,
}: IDefaultInput) => {
  return (
    <TextField
      defaultValue={defaultValue}
      sx={{ width: '100%', margin: '10px 0' }}
      required={required}
      id={id}
      label={label}
      variant="outlined"
      name={name}
      onChange={onChange}
      InputLabelProps={{ shrink: true }}
      error={error}
      helperText={helperText}
      disabled={disabled}
    />
  );
};

export default DefaultInput;
